import styled from "styled-components";

export const TabStyles = styled.div`
  width: auto;
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing[20]};
  margin: 0 8px 4px 8px;
  display: flex;
  align-items: center;
  background: transparent;
  border-radius: 8px;
  position: relative;
  transition: background 0.2s ease;
  user-select: none;

  &:first-child {
    margin-top: 8px;
  }

  &:last-child {
    margin-bottom: 8px;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.accent[50]};
  }

  ${({ $isActive, theme }) =>
    $isActive &&
    `
    background: ${theme.colors.accent[50]};

    &::before {
      content: '';
      position: absolute;
      left: 8px;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 50%;
      background: ${theme.colors.accent[500]};
      border-radius: 2px;
    }

    svg {
      color: ${theme.colors.accent[500]};
      fill: ${theme.colors.accent[500]};
    }
  `}

  .tabName {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b2.weight};
    font-size: ${({ theme }) => theme.typography.body.b2.size};
    line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
    color: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.accent[500] : theme.colors.semantic.text.strong};
    margin-left: ${({ theme }) => theme.spacing[12]};
  }
`;
